// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9438f227","389":"1c87b322","732":"710fa2e6","977":"8d27529a"}[chunkId] + ".chunk.js";
};